import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, postData } from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import { ReasonCaptureModal } from '../Common/ReasonCaptureModal';
import PageLayout from '../Layout/PageLayout';
import { Card, FormField, TextInput, Checkbox, Button, tokens } from '../UI';

export default function HubDetails() {
  const { id } = useParams();
  const history = useHistory();
  const isNew = id === 'new';
  const [form, setForm] = useState({ name: '', lat: '', lng: '', radius_meters: '50', active: true });
  const [pendingDelete, setPendingDelete] = useState(false);
  const [pendingSave, setPendingSave] = useState(false);

  useEffect(() => {
    if (isNew) return;
    fetchData(Endpoints.LIST_TRANSFER_HUBS)
      .then((res) => res.json())
      .then((res) => {
        const list = (res && res.data) || res || [];
        const found = Array.isArray(list) ? list.find((h) => h.id === id) : null;
        if (found) {
          setForm({
            name: found.name || '',
            lat: String(found.lat),
            lng: String(found.lng),
            radius_meters: String(found.radius_meters),
            active: found.active,
          });
        }
      });
  }, [id, isNew]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = (reason) => {
    const fd = new FormData();
    fd.append('name', form.name);
    fd.append('lat', form.lat);
    fd.append('lng', form.lng);
    fd.append('radius_meters', form.radius_meters);
    fd.append('active', form.active ? 'true' : 'false');
    fd.append('reason', reason);
    const endpoint = isNew ? Endpoints.CREATE_TRANSFER_HUB : Endpoints.UPDATE_TRANSFER_HUB(id);
    postData(endpoint, fd)
      .then((res) => res.json())
      .then(() => {
        setPendingSave(false);
        history.push('/transfer-hubs');
      });
  };

  const del = (reason) => {
    const fd = new FormData();
    fd.append('reason', reason);
    postData(Endpoints.DELETE_TRANSFER_HUB(id), fd)
      .then((res) => res.json())
      .then(() => {
        setPendingDelete(false);
        history.push('/transfer-hubs');
      });
  };

  return (
    <PageLayout title={isNew ? 'New transfer hub' : 'Edit transfer hub'}>
      <Card style={{ maxWidth: 560 }}>
        <FormField label="Name" htmlFor="hub-name">
          <TextInput id="hub-name" value={form.name} onChange={set('name')} />
        </FormField>

        <FormField label="Lat" htmlFor="hub-lat">
          <TextInput id="hub-lat" value={form.lat} onChange={set('lat')} />
        </FormField>

        <FormField label="Lng" htmlFor="hub-lng">
          <TextInput id="hub-lng" value={form.lng} onChange={set('lng')} />
        </FormField>

        <FormField label="Radius (m)" htmlFor="hub-radius">
          <TextInput id="hub-radius" value={form.radius_meters} onChange={set('radius_meters')} />
        </FormField>

        <FormField flush>
          <Checkbox
            label="Active"
            checked={!!form.active}
            onChange={(e) => setForm({ ...form, active: e.target.checked })}
          />
        </FormField>

        <div style={{ marginTop: tokens.spacing[5], display: 'flex', gap: tokens.spacing[2] }}>
          <Button onClick={() => setPendingSave(true)}>{isNew ? 'Create' : 'Save'}</Button>
          {!isNew && (
            <Button variant="danger" onClick={() => setPendingDelete(true)}>
              Delete
            </Button>
          )}
        </div>
      </Card>

      {pendingSave && (
        <ReasonCaptureModal
          title={isNew ? 'Create transfer hub' : 'Save transfer hub'}
          onCancel={() => setPendingSave(false)}
          onConfirm={save}
        />
      )}
      {pendingDelete && (
        <ReasonCaptureModal
          title="Delete transfer hub"
          onCancel={() => setPendingDelete(false)}
          onConfirm={del}
        />
      )}
    </PageLayout>
  );
}
